<aside class="pb-20 pt-2">
  <h2 class="text-center font-medium text-4xl mb-10">
    Search apartments
  </h2>
  <homey-housing-opportunities-search
    ngSkipHydration
    [route]="['/', 'apartments']"
    [excludeLotteryId]="excludeLotteryId()"
    [replace]="false"
    [dividerBackground]="'white'"
  />
</aside>

<homey-full-footer [defaultSignupRoute]="defaultSignupRoute()">
  <ng-content select="[footerTitle]">
    Apply in minutes<br />
    <span class="text-orange-gradient">
      We’ll handle the rest.
    </span>
  </ng-content>
</homey-full-footer>
